import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import NumberInput from '../../../../../../common/inputs/numberInput/NumberInput'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'

export interface BaseRentProps {}

const BaseRent: React.FC<FieldProps<CostsScreenValidationResult> & BaseRentProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <NumberInput
        id='base-rent'
        propertyName='baseRent'
        placeholder=''
        label={<span>{t('wizard.screen.costs.baseRent')}</span>}
        value={insertionData.baseRent ? parseNumber(insertionData.baseRent) : undefined}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        style={{}}
        errors={validationMessages!.baseRent ?? []}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
        }}
      />
    </div>
  )
}

export default BaseRent
